import React, {useState} from "react";
import CustomDialog from "../../../core/components/ui/CustomDialog";
import {Typography, Box, CircularProgress, FormControl, InputLabel, Select, MenuItem} from "@mui/material";
import { useDeviceManagement } from "../hooks/useDeviceManagement";
import CustomDialogLoaderComponent from "../../../core/components/common/custom-dialog-loader.component";

const UpdateStatusDialog = (props) => {
    const {open, setOpen, selectedDevice} = props;

    const {isUpdatingDevice, updateDeviceStatus} = useDeviceManagement();

    
    const [selectedStatus, setSelectedStatus] = useState(null);
    const [selectedEntryType, setSelectedEntryType] = useState(null);


    const handleStatusChange = (e) => {
        const value = e.target.value;
        setSelectedStatus(value);
        if (value === "Inactive") {
            setSelectedEntryType("OUT");
        } else {
            setSelectedEntryType(null);
        }
    }

    const handleSelectedEntry = (e) => {
        setSelectedEntryType(e.target.value)
        console.log('get selected entry', e.target.value)
    }

    const handleClose = () => {
        setOpen(false);
    }

    const handleUpdateStatus = () => {
        const parameters = {
            deviceId: selectedDevice.device_id,       
            status: selectedStatus ? selectedStatus : selectedDevice.status,
            entryType: selectedEntryType
        }

        updateDeviceStatus(parameters, setOpen)

    }

    const actions = [
        {
            label: "Update",
            onClick: (e) => 
                (selectedStatus || selectedEntryType) ? handleUpdateStatus(e) : null
        }
    ]

    const globalSx = {
       //
    }


    return (
        <>
            <CustomDialog
                open={open}
                onClose={ handleClose}
                title={<Typography sx={{fontWeight: 500}}>Update Status</Typography>}
                hasDividers={true}
                content={
                    <Box>
                        {(isUpdatingDevice) ? 
                            <Box sx={{mb: "80px"}}>
                                <CustomDialogLoaderComponent
                                    icon={<CircularProgress size={40} sx={{color: "#2196f3"}} />} 
                                    message={"Updating status..."}
                                />
                            </Box>
                        : 
                            <>
                                <Typography sx={{mb: (selectedStatus) ? 1 : 1, fontWeight: 600, fontSize: 15}}>
                                    Status
                                </Typography>

                                <FormControl fullWidth >
                                    {/* <InputLabel id="demo-simple-select-label" shrink={true} sx={{bgcolor:'white'}}>Subscription Type</InputLabel> */}
                                    <Select
                                        labelId="demo-simple-select-label"
                                        id="demo-simple-select"
                                        defaultValue={selectedDevice?.status}
                                        onChange={handleStatusChange}
                                    >
                                        <MenuItem value="Active">Active</MenuItem>
                                        <MenuItem value="Inactive">Inactive</MenuItem>
                                    </Select>
                                    
                                   
                                </FormControl>
                                

                                {(selectedStatus === "Active" || (!selectedStatus && selectedDevice?.status === "Active")) && (
                                    <>
                                        <Typography sx={{fontWeight: 600, mt: 2, fontSize: 15}}>
                                            Entry Type
                                        </Typography>
                                        <FormControl fullWidth >
                                            <Select
                                                labelId="demo-simple-select-label"
                                                id="demo-simple-select"
                                                defaultValue={selectedDevice?.entry_type}
                                                onChange={handleSelectedEntry}
                                            >
                                                <MenuItem value="IN">IN</MenuItem>
                                                <MenuItem value="OUT">OUT</MenuItem>
                                            </Select>
                                        </FormControl>
                                    </>
                                )}

                            </>
                        } 
                    </Box>
                }
                actions={!isUpdatingDevice && actions}
                maxWidth={"sm"}
                customStyles={{
                    actions: {
                        opacity: (selectedStatus || selectedEntryType && !isUpdatingDevice) ? "100%" : "55%",
                        cursor: (selectedStatus || selectedEntryType && !isUpdatingDevice) ? "pointer" : "not-allowed !important",
                        visibility: (isUpdatingDevice) ? "hidden" : "visible",
                    }
                }}
                globalSx={globalSx}
            />
        </>
    )
}

export default UpdateStatusDialog
